import type { DashboardMetrics } from '@shared/types';
import { api } from './api';

/**
 * Admin dashboard API client (#452).
 *
 *   - GET /admin/dashboard/metrics → `DashboardMetrics` (+ the active game's
 *     own top-level sections, read by its manifest's `dashboardSections`)
 *
 * Requires `adminRole >= 'viewer'`, enforced server-side. The SPA gate
 * (`<RequireAdmin minRole="viewer">` in `App.tsx`) already prevents non-admin
 * browsers from reaching the page.
 */
export async function getDashboardMetrics(): Promise<DashboardMetrics> {
  return api<DashboardMetrics>('/admin/dashboard/metrics');
}
